import React from 'react';
import Projects from '../components/Projects';

const ProjectsPage = () => {
  return (
    <div className="pt-20">
      <Projects />
    </div>
  );
};

export default ProjectsPage;
